import { render, staticRenderFns } from "./history_list.vue?vue&type=template&id=956ce464&scoped=true&"
import script from "./history_list.vue?vue&type=script&lang=js&"
export * from "./history_list.vue?vue&type=script&lang=js&"
import style0 from "./history_list.vue?vue&type=style&index=0&id=956ce464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956ce464",
  null
  
)

export default component.exports